import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyProfileComponent } from './pages/my-profile/my-profile.component';
import { UserProfileRoutingModule } from './user-profile.routing.module';
import { UserProfileService } from './services/user-profile.service';
import { ColumnChooserComponent } from '../../shared/components/column-chooser/column-chooser.component';
import { SharedStandAloneImports } from '../business-partners/model/prospect.model';
import { UpGeneralComponent } from './common/up-general/up-general.component';
import { UpRimsServiceComponent } from './common/up-rims-service/up-rims-service.component';
import { UpRimsSalesComponent } from './common/up-rims-sales/up-rims-sales.component';
import { DatePickerModule, DateRangePickerModule, DateTimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { NumericTextBoxModule, SignatureModule, UploaderModule } from '@syncfusion/ej2-angular-inputs';
import { UserProfilePopupComponent } from './pages/user-profile-popup/user-profile-popup.component';
import { UsersComponent } from './pages/users/users.component';
import { SignaturePopupComponent } from './common/up-general/signature-popup/signature-popup.component';
import { AddressesGridPopupComponent } from './common/up-general/addresses-grid-popup/addresses-grid-popup.component';
import { UpPreferencesComponent } from './common/up-preferences/up-preferences.component';
import { AssignmentGridComponent } from './common/assignment-grid/assignment-grid.component';
import { ExcelExportService } from '@syncfusion/ej2-angular-grids';
import { AdvancedEmployeeSearchPopupComponent } from './common/up-rims-service/advanced-employee-search-popup/advanced-employee-search-popup.component';
import { AdvancedIscCodesPopupComponent } from './common/up-rims-service/advanced-isc-codes-popup/advanced-isc-codes-popup.component';
import { DirectReportsComponent } from './pages/users/direct-reports/direct-reports.component';
import { RadioButtonModule } from '@syncfusion/ej2-angular-buttons';
import { ListViewModule } from '@syncfusion/ej2-angular-lists';
import { DropdownToggleDirective } from 'projects/shared/src/lib/directives/dropdown-toggle.directive';

import { GridModule, ColumnChooser, CommandColumn, ExcelExport, Filter, Freeze, Grid, InfiniteScroll, Page, Reorder, Resize, Sort, Toolbar } from '@syncfusion/ej2-angular-grids';
import { TreeGridModule, TreeGrid, 
    ColumnChooser as TreeColumnChooser, 
    CommandColumn as TreeCommandColumn, 
    ExcelExport as TreeExcelExport, 
    Filter as TreeFilter, 
    Freeze as TreeFreeze, 
    Page as TreePage, 
    Reorder as TreeReorder, 
    Resize as TreeResize, 
    Sort as TreeSort, 
    Toolbar as TreeToolbar} from '@syncfusion/ej2-angular-treegrid';

Grid.Inject(ColumnChooser, CommandColumn, Filter, Freeze, ExcelExport,  Page, Reorder, Resize, Sort, Toolbar, InfiniteScroll);
TreeGrid.Inject(TreeColumnChooser, TreeCommandColumn, TreeFilter, TreeFreeze, TreeExcelExport,  TreePage, TreeReorder, TreeResize, TreeSort, TreeToolbar);

@NgModule({
  declarations: [
    UsersComponent,
    MyProfileComponent,
    UserProfilePopupComponent,
    UpGeneralComponent,
    UpRimsSalesComponent,
    UpRimsServiceComponent,
    SignaturePopupComponent,
    AddressesGridPopupComponent,
    UpPreferencesComponent,
    AssignmentGridComponent,
    AdvancedEmployeeSearchPopupComponent,
    AdvancedIscCodesPopupComponent,
    DirectReportsComponent
  ],
  imports: [
    CommonModule,
    UserProfileRoutingModule,
    SharedStandAloneImports,
    DropdownToggleDirective,
    ColumnChooserComponent,
    DatePickerModule,
    DateTimePickerModule,
    UploaderModule,
    SignatureModule,
    NumericTextBoxModule,
    RadioButtonModule,
    ListViewModule,
    GridModule,
    TreeGridModule
  ],
  exports: [
    UsersComponent,
    MyProfileComponent,
    UserProfilePopupComponent
  ],
  providers: [
    UserProfileService,
    ExcelExportService
  ]
})
export class UserProfileModule { }
 